import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useArticlesStore } from '@/stores/articles';
import { computed } from 'vue';
import { ucfirst, useShortLengthsOverview } from '@/utils/utils';
import { useRoute } from 'vue-router';
import AjaxQueryWithSearchDropdown from '@/components/AjaxQueryWithSearchDropdown.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticlesFilters',
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const articlesStore = useArticlesStore();
        const route = useRoute();
        const isShortLengthsOverview = useShortLengthsOverview();
        const filters = computed(() => [
            // {
            //   key: 'articleGroup',
            //   placeholder: $t('Article group'),
            //   label: $t('Article group'),
            //   options: Object.entries(articlesStore.stats?.articleGroup || {}).map(([key, value]) => ({
            //     key,
            //     label: ucfirst(articlesStore.stats.articleGroupName[key]),
            //     count: value,
            //   })),
            // },
            {
                key: 'grade',
                placeholder: $t('Grade'),
                label: $t('Grade'),
                options: Object.entries(articlesStore.stats?.grade || {}).map(([key, value]) => ({
                    key,
                    label: key,
                    count: value,
                })),
            },
            {
                key: 'outerDiameter',
                placeholder: $t('Outer diameter'),
                label: $t('Outer diameter'),
                options: Object.entries(articlesStore.stats?.outerDiameter || {}).map(([key, value]) => ({
                    key,
                    label: key,
                    count: value,
                })),
            },
            // {
            //   key: 'x',
            // },
            {
                key: 'wallThickness',
                placeholder: $t('Wall thickness'),
                label: $t('Wall thickness'),
                options: Object.entries(articlesStore.stats?.wallThickness || {}).map(([key, value]) => ({
                    key,
                    label: key,
                    count: value,
                })),
            },
            {
                key: 'material',
                keyName: 'materialName',
                placeholder: $t('Material'),
                label: $t('Material'),
                options: Object.entries(articlesStore.stats?.material || {}).map(([key, value]) => ({
                    key,
                    label: ucfirst(articlesStore.stats.materialName[key]),
                    count: value,
                })),
            },
            {
                key: 'shape',
                keyName: 'shapeName',
                placeholder: $t('Shape'),
                label: $t('Shape'),
                options: Object.entries(articlesStore.stats?.shape || {}).map(([key, value]) => ({
                    key,
                    label: ucfirst(articlesStore.stats.shapeName[key]),
                    count: value,
                })),
            },
        ]);
        const filteredFilters = computed(() => filters.value.filter((filter) => {
            if (!['material', 'shape'].includes(filter.key)) {
                return true;
            }
            if (isShortLengthsOverview.value && filter.key === 'material') {
                return true;
            }
            if (!route.query.material && !route.query.shape) {
                return false;
            }
            const firstFilterQueryName = Object.keys(route.query).find((key) => ['material', 'shape'].includes(key));
            return ((firstFilterQueryName === 'material' && filter.key === 'shape') ||
                (firstFilterQueryName === 'shape' && filter.key === 'material'));
        }));
        const __returned__ = { $t, articlesStore, route, isShortLengthsOverview, filters, filteredFilters, AjaxQueryWithSearchDropdown };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
